import { posToDOMRect } from '@tiptap/core';
import { StatisticsSmall } from '@wix/wix-ui-icons-common';

import type { EditorPluginCreator } from './../ricos-types';
import { quickActionsModalSections, RicosPluginToolbarNames } from './../ricos-types';
import { changeSelectionToEndOfTextBlock } from './../wix-rich-content-common';

import { InsertModal } from './components/insert-modal/insert-modal';
import { SettingsModal } from './components/settings-modal/settings-modal';
import { INSERT_POLL_MODAL_ID } from './consts';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { pollConverter } from './poll-converter';
import { tiptapExtensions } from './tiptap/tiptap';
import type { PollPluginEditorConfig } from './types';
import { POLL_TYPE } from './types';

export const pluginPoll: EditorPluginCreator<
  PollPluginEditorConfig,
  { InsertModal: typeof InsertModal; SettingsModal: typeof SettingsModal }
> = config => {
  return {
    config: config ?? {},
    pmMarkConverters: [],
    pmNodeConverters: [pollConverter],
    type: POLL_TYPE,
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.POLL],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    getQuickActions: () => [
      {
        id: 'poll',
        title: 'QuickActionsPlugin_ActionTitle_Poll',
        icon: StatisticsSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ['vote', 'survey', 'questionnaire', 'feedback', 'voting', 'opinion', 'form'],
        command: ({ modalService, editor }) => {
          changeSelectionToEndOfTextBlock(editor);

          modalService.openModal({
            id: INSERT_POLL_MODAL_ID,
            Component: InsertModal,
            componentProps: {
              config: config ?? {},
            },
            noPadding: true,
            layout: 'floating',
            positioning: {
              referenceElement: {
                getBoundingClientRect: () =>
                  posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  ),
              },
              placement: 'bottom-start',
            },
            dragHandleSelector: '[data-drag-handler]',
            enableDrag: true,
            withTransition: true,
          });
        },
      },
    ],
    __exports: {
      InsertModal,
      SettingsModal,
    },
  };
};
